var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.sourcesLoaded
        ? _c("DropdownFilter", {
            attrs: {
              withoutLoading: "",
              placeholder: "Select Source",
              value: _vm.selectedSource,
              multiple: false,
              options: _vm.sources,
              customMultiStyleParent: _vm.getcontainerStyle,
            },
            on: { input: _vm.update },
          })
        : _c("InputPlaceholder"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }